import React from 'react';
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from 'react-compare-slider';

function CompareSlider({
  img1,
  img2,
  title,
  age,
  newSize,
  oldSize,
  desc,
  duration,
}) {
  return (
    <div className="border border-grey rounded md:w-3/4 w-full rounded-lg shadow-lg m-4 p-2">
      <div className="mx-auto">
        <div className="mx-auto text-gray-500 mb-3 text-center text-xs font-bold">
          در مدت: {duration}
        </div>
        <ReactCompareSlider
          itemOne={
            <ReactCompareSliderImage
              style={{
                height: '400px',
                width: '500px',
              }}
              src={img1}
              srcSet={img1}
              alt="عکس قبل از دوره شیپ آپ"
            />
          }
          itemTwo={
            <ReactCompareSliderImage
              style={{
                height: '400px',
                width: '500px',
              }}
              src={img2}
              srcSet={img2}
              alt="عکس بعد از دوره شیپ آپ"
            />
          }
        />
      </div>
      <div className="flex flex-col my-2 justify-start">
        <span className="text-gray-500  font-bold flex flex-row justify-center gap-2">
          <div className=" text-right">کیلوگرم</div>
          <div className="">{title} </div>
          <span className="text-gray-500 ">:کاهش وزن </span>
        </span>
        <span className="text-gray-500  font-bold flex flex-row justify-center gap-2">
          <div className=" text-right">سانتی متر</div>
          <div className=" text-right">{desc}</div>
          <div className=" text-right">:کاهش سایز دور کمر</div>
        </span>

        <div className="mx-auto text-gray-500 text-right">سن: {age}</div>
        <div className="mx-auto text-gray-500 text-right">
          سایز قدیم: {oldSize} <br />
        </div>
        <div className="mx-auto text-gray-500 text-right">
          سایز جدید: {newSize}
        </div>
      </div>
    </div>
  );
}

export default CompareSlider;
